import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, OnInit, signal } from '@angular/core';
import { APP_SETTINGS, AuthService, SpinnerService, UtilityService } from '@services';
import { AdminService } from '../admin/admin.service';
import { PartsBulletinsService } from '../parts-bulletins/parts-bulletins.service';
import { BulletinService } from '../servicebulletin/bulletin.service';
import { MultiTabComponent } from '../../shared/components/multi-tab/multi-tab.component';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MultiTabComponent,
        NgIf,
        NgFor,
        RouterLink,
        DatePipe,
    ],
})
export class HomeComponent implements OnInit {

  newDocsCount = signal(0);
  tabs = computed(() => [{ badge: this.newDocsCount(), label: 'NEW' }, { label: 'HISTORY' }, { label: 'SAVED' }]);
  screenWidth: number;
  expandBulletin = {};

  info = 'Loading...';
  bulletins = []
  noMessagesMessage = 'Loading... '

  isShowNew = false;
  isShowHistory = false;
  isShowSaved = true;
  toggle: boolean = false;

  isDesc = false;
  column = 'id';
  direction: number;

  APP_SETTINGS;
  cssStyleClassNew;
  cssStyleClassHistory;
  cssStyleClassSaved;
  setFontStyle;

  activeBulletins = '';
  bulletionOptions = {
    'sib': 'Service Bulletins',
    'pbs': 'Parts Bulletins'
  };

  private username: string;
  private makeName: string;
  public numOfItems = 6;
  public allMessages: any[] = [];
  public messagesEnabled: boolean;

  constructor(
    private readonly utilityService: UtilityService,
    private readonly partsBulletinService: PartsBulletinsService,
    private readonly spinnerService: SpinnerService,
    private readonly authService: AuthService,
    private readonly adminService: AdminService,
    private readonly bulletinService: BulletinService,
    private readonly changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
    this.messagesEnabled = APP_SETTINGS.isExternal === 'true';
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.activeBulletins = this.bulletionOptions['sib'];
    this.APP_SETTINGS = APP_SETTINGS;
    this.setMakeName();
    this.showNew();
  }

  onTabChange(selectedTab: string) {
    if (selectedTab === 'NEW') {
      this.showNew();
    } else if (selectedTab === 'HISTORY') {
      this.showHistory();
    } else if (selectedTab === 'SAVED') {
      this.showSaved();
    }
  }

  private setMakeName(): void {
    if (APP_SETTINGS.isMINI === 'true') {
      this.makeName = 'MINI';
    } else if (APP_SETTINGS.isMOTORRAD === 'true') {
      this.makeName = 'MOTORRAD';
    } else if (APP_SETTINGS.isRollsRoyce === 'true') {
      this.makeName = 'ROLLSROYCE';
    } else {
      this.makeName = 'BMW';
    }
  }

  public toggleMessages(): void {
    this.toggle = !this.toggle;
    if (this.toggle && this.allMessages.length === 0) {
      this.getAllMessages();
    }
  }

  private getAllMessages(): void {
    if (this.messagesEnabled) {
      this.adminService.getAllMessages(this.makeName).subscribe(data => {
        if (data.length > 0) {
          this.allMessages = data;
          this.allMessages = this.allMessages.filter(message => {
            if (message.hasOwnProperty('location')) {
              return message['location'].toUpperCase() === 'HOME';
            }
          });
          this.allMessages.sort((a, b) => {
            if (a['createdDate'] < b['createdDate']) {
              return 1;
            } else if (a['createdDate'] > b['createdDate']) {
              return -1;
            } else {
              return 0;
            }
          });
        } else {
          this.noMessagesMessage = 'No messages found.'
        }
      });
    }
  }

  showNew() {
    this.isShowNew = true;
    this.isShowHistory = false;
    this.isShowSaved = false;
    this.info = '';
    this.spinnerService.show('bmwSpinner');
    switch (this.activeBulletins) {
      case this.bulletionOptions['sib']:
        this.bulletinService.getNewBulletinService().subscribe(data => {
          this.spinnerService.hide('bmwSpinner');
          this.bulletins = data.content;
          this.newDocsCount.update(x => this.bulletins.length);
          this.info = this.bulletins.length === 0 ? 'No New Content added' : '';
          this.changeDetector.detectChanges();
        },
          error => {
            this.info = 'No Bulletins Found';
            this.spinnerService.hide('bmwSpinner');
          });
        break;
      case this.bulletionOptions['pbs']:
        this.partsBulletinService.getNewPartsBulletins().subscribe(data => {
          this.spinnerService.hide('bmwSpinner');
          this.bulletins = data;
          this.newDocsCount.update(x => data['newSize']);
          this.info = (data.length === 0 || this.newDocsCount() === 0) ? 'No New Content added' : '';
          this.changeDetector.detectChanges();
        },
          error => {
            this.info = 'No Bulletins Found';
            this.spinnerService.hide('bmwSpinner');
          });
        break;
    }
  }
  showHistory() {
    this.spinnerService.show('bmwSpinner');
    this.isShowNew = false;
    this.isShowHistory = true;
    this.isShowSaved = false;
    this.info = '';
    switch (this.activeBulletins) {
      case this.bulletionOptions['sib']:
        this.bulletinService.getHistoryBulletinService(this.username).subscribe(data => {
          this.spinnerService.hide('bmwSpinner');
          this.bulletins = data;
          this.info = this.bulletins.length === 0 ? 'No History Found' : '';
          this.changeDetector.detectChanges();
        },
          error => {
            this.info = 'No Bulletins Found';
            this.spinnerService.hide('bmwSpinner');
          }
        );
        break;
      case this.bulletionOptions['pbs']:
        this.partsBulletinService.getHistoryPartsBulletins(this.username).subscribe(data => {
          this.spinnerService.hide('bmwSpinner');
          this.bulletins = data;
          this.changeDetector.detectChanges();
        },
          error => {
            this.info = 'No History Found';
            this.spinnerService.hide('bmwSpinner');
          });
        break;
    }
  }
  showSaved() {
    this.isShowNew = false;
    this.isShowHistory = false;
    this.isShowSaved = true;
    this.info = '';
    this.spinnerService.show('bmwSpinner');
    switch (this.activeBulletins) {
      case this.bulletionOptions['sib']:
        this.bulletinService.getUserSavedServieBulletins(this.username).subscribe(data => {
          this.spinnerService.hide('bmwSpinner');
          this.bulletins = (data?.[0] ?? {}).content;
          if (data?.numberOfElements === 0) {
            this.info = 'No Saved Bulletins Found';
          }
          this.changeDetector.detectChanges();
        },
          error => {
            this.info = 'No Saved Bulletins Found';
            this.spinnerService.hide('bmwSpinner');
          });
        break;
      case this.bulletionOptions['pbs']:
        this.partsBulletinService.getUserSavedPartsBulletins(this.username).subscribe(data => {
          this.spinnerService.hide('bmwSpinner');
          this.bulletins = data;
          if (this.bulletins.length === 0) {
            this.info = 'No Saved Bulletins Found';
          }
          this.changeDetector.detectChanges();
        },
          error => {
            this.info = 'No Saved Bulletins Found';
            this.spinnerService.hide('bmwSpinner');
          });
        break;
    }
  }
  changeBulletinDisplay(bulletin) {
    this.activeBulletins = this.bulletionOptions[bulletin];
    this.showNew();
  }
  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc;
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }
}
